/**
 * RecordingInfo behavior — the authored marker of a recording
 *
 * Data-only and inert (RECORDINGS_SPEC §4.3): no attach work, nothing loaded,
 * nothing rendered, no runtime reads it. It sits on a recording's `Recording`
 * node so that editors can describe the recording and readers can find it —
 * by this behavior, never by node name or subtree shape.
 *
 * It travels with the scene document like any behavior, in the node's
 * `extras.trace.behaviors`, so a save and reload keeps it verbatim.
 */

import { TraceBehavior } from "./tracebehavior";
import type { RecordingInfoData } from "../scenedata/behaviors/recordinginfodata";

export class RecordingInfo extends TraceBehavior<RecordingInfoData> {
    static readonly behaviorType = "RecordingInfo" as const;

    /**
     * An author's name, a device string or an app label is text somebody
     * typed or a device reported, not authored bindings. Without this, a name
     * like `Ana {live}` would be read as a property reference and the
     * in-memory record would stop matching the file (see Provenance).
     */
    static readonly literalData = true;
}
